import Vue from 'vue'
import Component from 'vue-class-component'
import { judgeDeviceType } from "@/utils/device"
import { toAppMember } from '@/utils/utils'
import { showConfirmDialog } from '@/utils/util'
import { Dialog } from 'vant'

@Component({
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    textLength: {
      type: Number,
      default: 0
    },
    videoStyle: {
      type: String,
      default: ''
    },
    speakerName: {
      type: String,
      default: ''
    },
    speakerStyle: {
      type: String,
      default: '默认'
    },
    speakerSpeed: {
      type: String,
      default: '1.0'
    },
    leftCount: {
      type: Number,
      default: 0
    },
    totalCount: {
      type: Number,
      default: 0
    },
    // 判断会员
    isVip: {
      type: Boolean,
      default: false
    },
    // 扣减次数
    deductions: {
      type: Number,
      default: 0
    },
    isSubmiting: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    'visible': {
      handler(state) {
        this.isVisible = state
      }
    }
  }
})
export default class VideoContentPopup extends Vue {
  // 判断是/否是 app 页面
  isApp = judgeDeviceType.isAPP

  isVisible = false

  get isSmartClip() {
    return this.$props.type === 'SmartClip';
  }
  /** 关闭弹窗 */
  handleHidePopup() {
    this.$emit('close')
  }
  /** 确认生成视频 */
  confirmGenerateVideo() {
    if (!this.$props.leftCount || (this.$props.deductions > this.$props.leftCount)) {
      return
    }
    this.$emit('confirm')
  }
  /** 跳转到购买会员页面 */
  toVipPage() {
    if(this.isApp) {
      toAppMember('')
    } else {
      this.$navigateTo({
        url: '/mine-package/pages/recharge-vip/recharge-vip'
      })
    }
    
  }
  toPackagePage() {
    if (this.isApp) {
      toAppMember('EXPOSE_VIDEO')
    } else {
      this.$navigateTo({
        url: '/mine-package/pages/recharge-vip/recharge-vip?target=EXPOSE_VIDEO'
      })
    }
    
  }
  /**
   * 显示扣减说明
   */
  showDeductInstructions() {
    Dialog.alert({
      title: '扣减说明',
      message: '每1000字扣除1次次数，不足1000字按1000字计算扣减次数',
      className: 'yuan_confirm tip_alert',
      confirmButtonText: '我知道了'
    })
  }
}
